import React from "react";
import { Card } from "react-bootstrap";

export default function PracticeHeader({
	questionData, isAttempted
}) {
	
	const getComplexity = (req_type, comp) => {
		let complexity = "";
		
		switch (comp) {
			case 0:
				complexity = req_type === "label" ? "Easy" : "easy";
				break;
			case 1:
				complexity = req_type === "label" ? "Medium" : "medium";
				break;
			case 2:
				complexity = req_type === "label" ? "Difficult" : "difficult";
				break;
		}
		return complexity;
	};

	return (
		<div style={{marginTop:"10px"}} className="cursor-default" >
			<Card.Title  style={{marginTop:"0"}} tag="h4">
				{questionData.q_title ? questionData.q_title : `#${questionData.id}`}
			</Card.Title>

			<span className={`complexity-badge cursor-default position-relative ${getComplexity("class",questionData.complexity)}`}
				>
				{getComplexity("label", questionData.complexity)}
				<span className="info-icon-wrapper">
					<i className="bi bi-info-circle-fill info-icon"></i>
					<span className="custom-tooltip">
					{/* {getComplexity("tooltip", questionData.complexity)} */}
					Difficulty level: Indicates the relative difficulty of this question based on complexity.
					</span>
				</span>
			</span>

			{isAttempted &&
				<span className="attemped-badge text-uppercase ms-2">Attempted</span>
			}
		</div>
	);
}